export const CREATE_MEMBER = "CREATE_MEMBER";
export const GET_MEMBERS = "GET_MEMBERS";
export const GET_SINGLE_MEMBER = "GET_SINGLE_MEMBER";
export const DELETE_MEMBER = "DELETE_MEMBER";
export const UPDATE_MEMBER = "UPDATE_MEMBER";
export const CHANGE_MEMBER_STATUS = "CHANGE_MEMBER_STATUS";